import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../hooks/useTranslation';

export const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    const newLang = language === 'fr' ? 'en' : 'fr';
    setLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-3 py-2 rounded-lg bg-white/10 backdrop-blur-md border border-white/20 hover:bg-white/20 transition-all"
    >
      <Globe className="w-4 h-4 text-white" />
      <span className="text-white font-medium text-sm uppercase">
        {language === 'fr' ? 'FR' : 'EN'}
      </span>
    </button>
  );
};